// extracted by mini-css-extract-plugin
module.exports = {"FictivePortfolio":"FictivePortfolio_FictivePortfolio__tYzUX","active":"FictivePortfolio_active__3PMng","spindindust":"FictivePortfolio_spindindust__TF3Ep"};